import * as aor from "react-admin";
import React from "react";

const NotiticationsTitle = ({ record }) => {
    return <span>Notifiche</span>;
};

export default ({ permissions, ...props }) => (
    <aor.List title={<NotiticationsTitle />} {...props} />
);



// WEBPACK FOOTER //
// ./src/resources/Notifications/List.js